'use client';

import Courses from '@/components/Courses';

const CoursesPage = () => (
  <Courses />
);

export default CoursesPage;
